import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { matchPath } from 'react-router';
import { Routes } from '../../../routes/top-level-routes';
import { routes as authRoutes } from '../../../modules/LoginRouter/routes';

export const shouldRedirectToOnboarding = (
  pathname: string,
  onboardingSignupStep: OnboardingSignupStep,
  needsToCreateCompany: boolean,
) => {
  const needsToCompleteSignup =
    onboardingSignupStep !== OnboardingSignupStep.NONE;
  const onSignupPage = pathname === authRoutes.signup.path;
  const onSignoutPage = pathname === Routes.signout.path;
  const onSubscribe = matchPath(pathname, {
    path: Routes.subscribe.path,
    exact: true,
    strict: false,
  });
  const onThankYouPage = matchPath(pathname, {
    path: Routes.thankYou.path,
    exact: true,
    strict: false,
  });

  const onOnboarding =
    pathname.indexOf(Routes.signupOnboarding.getLink()) !== -1;

  return (
    needsToCompleteSignup &&
    !onSubscribe &&
    !onThankYouPage &&
    !onSignupPage &&
    !onSignoutPage &&
    !onOnboarding &&
    !needsToCreateCompany
  );
};
